/* eslint-disable @typescript-eslint/no-explicit-any */
import DynamicForm from '@/shared/components/DynamicForm/DynamicForm'
import Button from '@/shared/components/Button/Button'
import { useTranslation } from 'react-i18next'
import { useState } from 'react'
import styles from './TablesModal.module.scss'
import Modal from '../Modal'

import { useTablesFormConfig } from '@/features/table-cards/hooks/useTablesFormConfig'
import { useTableCardsQuery } from '@/features/table-cards/hooks/useTableCardsQuery'
import { useFormDirtyStore } from '@/shared/store/useFormDirtyStore'
import ConfirmationModal from '../ConfirmationModal/ConfirmationModal'

interface TablesModalProps {
  closeModal: () => void
  isOpen: boolean
}

function TablesModal(props: TablesModalProps) {
  const { closeModal, isOpen } = props
  const { t } = useTranslation()
  const setIsDirty = useFormDirtyStore(s => s.setIsDirty)
  const isDirty = useFormDirtyStore(s => s.isDirty)
  const resetIsDirty = useFormDirtyStore(s => s.reset)

  const formConfig = useTablesFormConfig()
  const { postTables } = useTableCardsQuery()

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false)

  const tablesFromConfig = {
    ...formConfig,
    id: 'tablesModalForm',
    onSubmit: (data: any) => {
      const payload = data.numberOfTables

      postTables(payload)
      closeModal()
    }
  }

  const handleOnConfirmClose = () => {
    resetIsDirty()
    closeModal()
    setIsConfirmationModalOpen(false)
  }

  const handleOnClose = () => {
    if (isDirty) {
      setIsConfirmationModalOpen(true)
    } else {
      closeModal()
    }
  }

  return (
    <>
      <Modal
        title={t('TABLES_MODAL.TITLE')}
        size="fit-content"
        onClose={handleOnClose}
        isOpen={isOpen}
      >
        <div className={styles.tablesModalWrapper}>
          <DynamicForm
            {...tablesFromConfig}
            setIsDirty={setIsDirty}
            superCondensed
            formErrorMessage={t('SIDEBAR_ACCORDION.FORM_ERROR_MESSAGE')}
          />
          <div className={`${styles.tablesModalButtonContainer}`}>
            <Button
              variant="contained"
              color="primary"
              label={t('COMMON.SUBMIT')}
              type="submit"
              form={tablesFromConfig.id}
            />
            <Button
              variant="contained"
              color="secondary"
              label={t('COMMON.CANCEL')}
            />
          </div>
        </div>
      </Modal>
      <ConfirmationModal
        isOpen={isConfirmationModalOpen}
        onConfirm={handleOnConfirmClose}
        onClose={() => setIsConfirmationModalOpen(false)}
        title={t('CONFIRMATION_MODAL.TITLE')}
        message={t('CONFIRMATION_MODAL.DESCRIPTION')}
      />
    </>
  )
}
export default TablesModal
